import { c } from "./colors";
import { Frame, type IllustrationProps } from "./Frame";

export function PlansIllustration(props: IllustrationProps) {
  return (
    <Frame {...props}>
      <path
        d="M44 108L38 62L62 82L80 52L98 82L122 62L116 108Z"
        fill={c.a400}
        stroke={c.a400}
        strokeWidth="6"
      />
      <rect x="44" y="108" width="72" height="14" rx="7" fill={c.a500} />
      <circle cx="38" cy="56" r="6" fill={c.a300} />
      <circle cx="80" cy="44" r="6" fill={c.a300} />
      <circle cx="122" cy="56" r="6" fill={c.a300} />
      <circle cx="80" cy="92" r="7" fill={c.n0} />
      <circle cx="58" cy="97" r="4" fill={c.n0} />
      <circle cx="102" cy="97" r="4" fill={c.n0} />
    </Frame>
  );
}
